var _linearGradient, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaydiumLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    viewBox: "0 0 120 33",
    width: 120,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 28.3168,
    x2: -1.73336,
    y1: 8.19162,
    y2: 20.2086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c200fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489658,
    stopColor: "#3772ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489758,
    stopColor: "#3773fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ac4be"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m41.2458 20.1947-1.4793-2.5554h-2.166v2.5554h-1.2741v-7.673h3.8364c.4677-.0037.9274.121 1.3291.3605.4017.2396.7299.5848.949.998.219.4132.3204.8786.2932 1.3455-.0273.4669-.1821.9174-.4477 1.3023-.2774.4083-.6688.7259-1.1255.9132l1.5785 2.7535zm-1.083-6.3706h-2.5623v2.5482h2.5623c.1675-.0001.3331-.0347.4866-.1017.1534-.0669.2914-.1649.4053-.2876.1764-.1791.2962-.4061.3445-.6528s.023-.5022-.0728-.7346c-.0959-.2324-.2579-.4315-.4661-.5725-.2081-.1409-.4532-.2175-.7045-.2202zm13.6402-1.3024-3.8436 7.673h1.4299l2.4137-4.8063 2.4067 4.8063h1.4298zm16.1953 0h-1.628l-2.1873 2.8313-2.1801-2.8313h-1.6351l3.2065 4.0913v3.5817h1.2741v-3.6454zm6.5262 0h2.5553c1.0152.0074 1.9867.414 2.7046 1.1319.7179.7178 1.1245 1.6894 1.1319 2.7046-.0056 1.0158-.4116 1.9883-1.1299 2.7066-.7182.7183-1.6908 1.1243-2.7066 1.1299h-2.5553zm2.5553 6.3705c.6771-.0018 1.326-.2717 1.8048-.7505s.7486-1.1276.7505-1.8048c-.0074-.6754-.279-1.3211-.7566-1.7987s-1.1233-.7492-1.7987-.7566h-1.2883v5.1106zm12.3519-6.3705h-1.2741v7.673h1.2741zm13.6333 4.4664c.007.4221-.073.8411-.235 1.2309-.162.3897-.402.7419-.707 1.0342-.447.4472-1.016.7516-1.636.8747-.621.123-1.263.0592-1.847-.1834s-1.0824-.6531-1.4326-1.1794-.5363-1.1448-.5346-1.777v-4.4664h1.2741v4.4664c0 .5088.2021.9967.5621 1.3565.359.3597.847.5618 1.356.5618s.997-.2021 1.357-.5618c.359-.3598.561-.8477.561-1.3565v-4.4664h1.282zm8.515 3.2066v-4.5868l2.569 2.5623 2.556-2.5623v4.5868h1.295v-7.673l-3.851 3.8365-3.836-3.8365v7.673z",
    fill: "#f1f1f2",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.8625 12.281v11.4104l-12.6916 7.3261-12.69859-7.3261v-14.65937l12.69859-7.33322 9.7541 5.63441 1.4723-.84941-11.2264-6.48381-14.1709 8.18262v16.35818l14.1709 8.1826 14.171-8.1826v-13.1092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6176 23.6985h-2.12353v-7.1209h7.07843c.6697-.0074 1.3095-.2782 1.7811-.7538.4716-.4755.737-1.1176.7388-1.7874.0038-.3311-.0601-.6596-.1879-.9651-.1279-.3056-.3168-.5817-.5554-.8115-.2308-.2372-.5071-.4253-.8124-.553-.3053-.1278-.6333-.1925-.9642-.1903h-7.07843v-2.16595h7.08543c1.2405.00743 2.4281.50351 3.3053 1.38065.8771.8772 1.3732 2.0648 1.3806 3.3052.0076.9496-.2819 1.8777-.8281 2.6544-.5027.7432-1.2111 1.3237-2.0386 1.6705-.8194.2599-1.6745.3889-2.5341.3823h-4.247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2159 23.5215h-2.4775l-1.9111-3.3339c.7561-.0463 1.5019-.1988 2.2155-.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3831 9.90975 1.4652.81405 1.4653-.81405v-1.72005l-1.4653-.84941-1.4652.84941z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaydiumLogo);
export default __webpack_public_path__ + "static/media/raydiumLogo.cf5a7a0fd58fd2c3245479659eb961e9.svg";
export { ForwardRef as ReactComponent };